interface StatusBannerProps {
  kind: 'error' | 'success';
  message: string;
}

/**
 * The one error/success banner shape in this app, lifted verbatim from
 * LoginPage's `?error=` banner (border-destructive-border / bg-destructive-soft
 * / text-destructive-soft-foreground) so a second copy of that token
 * combination does not drift from the first. `success` reuses the primary
 * brand-subtle surface the shell's role pill already uses — no new color
 * role invented for one banner.
 */
export function StatusBanner({ kind, message }: StatusBannerProps) {
  if (kind === 'error') {
    return (
      <p
        role="alert"
        className="rounded-card border border-destructive-border bg-destructive-soft px-3 py-2 text-meta text-destructive-soft-foreground"
      >
        {message}
      </p>
    );
  }
  return (
    <p
      role="status"
      className="rounded-card bg-surface-brand-subtle px-3 py-2 text-meta text-fg-primary"
    >
      {message}
    </p>
  );
}
